import { Suspense, lazy } from 'react';
import type { SlotEntry, SlotProps } from '@saas/ui';

/**
 * 画面の差し込み口（`@saas/ui` の `Slot`）に relationship が出すもの。登録は apps/web（リード）が行う。
 * 部品は `lazy` + `Suspense`（初期バンドルを太らせない）。中身が空なら null を返して場所を取らない。
 *
 * いまのところ 1 つだけ: **連絡先の詳細（crm）に開示請求の導線**（03 §17.9・gap B12）。
 * 顧客の関係プロファイル（`/relationship/customers/:id`）は独立ページのままで、crm からはリンクで飛ぶ
 */
const ContactDisclosurePanel = lazy(() => import('./components/ContactDisclosurePanel.js'));

export const relationshipSlots: SlotEntry[] = [
  {
    id: 'relationship.contactDisclosure',
    module: 'relationship',
    slot: 'record.panel',
    subjectTypes: ['contact'],
    // 開示請求に答えられる人（admin / manager）にだけ出す。サーバ側も同じ権限を要求する
    permission: ['relationship.handover.read'],
    order: 60,
    Component: ({ subjectId }: SlotProps) => (
      <Suspense fallback={null}>
        <ContactDisclosurePanel subjectId={subjectId} />
      </Suspense>
    ),
  },
];
